import React from "react";
import { Link } from "react-scroll";
import "./Header.scss";

const Header = ({ selectedNav, selectNav }) => {
  return (
    <div className="header animate__animated animate__fadeInDown">
      <div>
        <img src="../header-logo.jpg" class="header-logo" alt="Logo"></img>
      </div>
      <div className="header-navbar">
        <Link
          className={selectedNav === "INTRO" ? "header-nav-selected" : null}
          onClick={() => selectNav("INTRO")}
          to="intro"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Intro</p>
        </Link>
        <Link
          className={selectedNav === "ABOUT" ? "header-nav-selected" : null}
          onClick={() => selectNav("ABOUT")}
          to="about"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>About</p>
        </Link>
        <Link
          className={selectedNav === "TECHNICAL SKILLS" ? "header-nav-selected" : null}
          onClick={() => selectNav("TECHNICAL SKILLS")}
          to="technical-skills"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Technical skills</p>
        </Link>
        <Link
          className={selectedNav === "SOFT SKILLS" ? "header-nav-selected" : null}
          onClick={() => selectNav("SOFT SKILLS")}
          to="soft-skills"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Soft skills</p>
        </Link>
        <Link
          className={selectedNav === "EDUCATION" ? "header-nav-selected" : null}
          onClick={() => selectNav("EDUCATION")}
          to="education"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Education</p>
        </Link>
        <Link
          className={
            selectedNav === "EXPERIENCE" ? "header-nav-selected" : null
          }
          onClick={() => selectNav("EXPERIENCE")}
          to="experience"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Experience</p>
        </Link>
        <Link
          className={selectedNav === "PROJECTS" ? "header-nav-selected" : null}
          onClick={() => selectNav("PROJECTS")}
          to="projects"
          offset={1}
          containerId="body"
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Projects</p>
        </Link>
        <Link
          className={selectedNav === "CONTACT" ? "header-nav-selected" : null}
          onClick={() => selectNav("CONTACT")}
          containerId="body"
          to="contact"
          offset={1}
          spy={true}
          smooth={true}
          duration={1000}
        >
          <hr />
          <p>Contact</p>
        </Link>
        <i className="fas fa-chevron-left"></i>
      </div>
    </div>
  );
};

export default Header;
